<template>
  <div>
    <b-tabs horizontal pills fill v-model="activeTab">
      <b-tab title="Overview">
        <training-overview v-if="activeTab == 0" />
      </b-tab>
      <b-tab title="Participation">
        <training-participation v-if="activeTab == 1" />
      </b-tab>
      <b-tab title="Trends">
        <training-trends v-if="activeTab == 2" />
      </b-tab>
      <b-tab title="Staff Listing">
        <staff-listing v-if="activeTab == 3" />
      </b-tab>
      <b-tab title="E-Learning [CPD] Courses">
        <cpd-attendance v-if="activeTab == 4" />
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import TrainingOverview from './TrainingOverview.vue'
import TrainingParticipation from './TrainingParticipation.vue'
import TrainingTrends from './TrainingTrends.vue'
import StaffListing from './StaffListing.vue'
import CpdAttendance from './CpdAttendance.vue'
import store from '@/store'
import reportStoreModule from './reportStoreModule'

const STORE_MODULE = 'trainingReports'

export default {
  components: {
    TrainingOverview,
    TrainingParticipation,
    TrainingTrends,
    StaffListing,
    CpdAttendance,
  },

  // The tabs share one store module. It lives here, for the page's lifetime:
  // when a tab owned it, switching away from that tab unregistered it while
  // the newly shown tab was still using it, leaving that tab dead.
  created() {
    if (!store.hasModule(STORE_MODULE)) store.registerModule(STORE_MODULE, reportStoreModule)
  },

  beforeDestroy() {
    if (store.hasModule(STORE_MODULE)) store.unregisterModule(STORE_MODULE)
  },

  data() {
    return {
      activeTab: 0,
    };
  },

  methods: {},
};
</script>
